import React from 'react';

// function Score({ score, onStartNewQuiz }) {
//     return (
//       <div>
//         <div className="alert alert-success" role="alert">
//           You scored {score} out of 10!
//         </div>
//         <button className="btn btn-primary" onClick={onStartNewQuiz}>Start New Quiz</button>
//       </div>
//     );
//   }

function getGradeCategory(score) {
  if (score >= 9) return "Dumbledore's Apprentice";
  if (score >= 7) return "Auror in Training";
  if (score >= 5) return "Intermediate Wizard";
  if (score >= 3) return "Novice Wizard";
  return "Wizard des champs";
}

function Score({ score, onStartNewQuiz }) {
  return (
      <div>
          <div className="alert alert-success" role="alert">
              You scored {score} out of 10!
              <div className="grade-category">
                  {getGradeCategory(score)}
              </div>
          </div>
          <button className="btn btn-primary" onClick={onStartNewQuiz}>Start New Quiz</button>
      </div>
  );
}


export default Score;
